import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App.js";
import { ErrorBoundary } from "./components/ui/ErrorBoundary.js";
import "./app/global.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root element nicht gefunden.");

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
